import {
  setPartnerCode,
  setPartnerParams,
  setReferredBy,
  setUtmParams,
} from "@/app/utils/services/service/localStorageService";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

export default function useTracking() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const partnerCode = searchParams.get("partner");
    const referredBy = searchParams.get("ref");
    const qbxAuthId = searchParams.get("qbx_auth_id");

    if (partnerCode) {
      setPartnerCode(partnerCode);
    }

    if (referredBy) {
      setReferredBy(referredBy);
    }

    if (qbxAuthId) {
      setPartnerParams(JSON.stringify({ userId: qbxAuthId }));
    }

    const utmParams: Record<string, string> = {};
    searchParams?.forEach((value, key) => {
      if (key.startsWith("utm_")) {
        const cleanKey = key.replace("utm_", "");
        utmParams[cleanKey] = value;
      }
    });

    if (Object.keys(utmParams).length > 0) {
      setUtmParams(JSON.stringify(utmParams));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
